module.exports = __webpack_public_path__ + "img/home-background.3c6f3b00.png";